<div class="flex h-full w-full flex-row">
  <app-toolbox
    [orientation]="'vertical'"
    [sections]="toolboxSections()"
    class="h-full w-12 shrink-0 overflow-hidden"></app-toolbox>

  <app-data-visu-container
    [visibleComponents]="visibleComponents()"
    class="data-visu-container flex h-full w-full flex-row overflow-hidden"
    [canFilterData]="filteringEnabled()"
    [inPlaceEditingEnabled]="inPlaceEditingEnabled()" />
</div>
